import type {LayoutPayload} from '@github-ui/code-view-types'
import {getQueryClient} from '@github-ui/query-client'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import type {RefInfo} from '@github-ui/repos-types'
import {useEffect} from 'react'

import {codeViewLayoutRoute} from '../routes/code-view-layout-route'

export function useUpdateRefInfoAndPath(refInfo: RefInfo, path: string) {
  const {queryKey: layoutQueryKey, isFetching} = useRouteQuery(codeViewLayoutRoute, 'mainQuery')

  useEffect(() => {
    const queryClient = getQueryClient()
    const layoutData = queryClient.getQueryData<{payload: LayoutPayload}>(layoutQueryKey)

    if (!layoutData) return

    queryClient.setQueryData(layoutQueryKey, (oldData: {payload: LayoutPayload} | undefined) => {
      if (!oldData) return oldData

      return {
        ...oldData,
        payload: {
          ...oldData.payload,
          refInfo: {
            ...oldData.payload.refInfo,
            ...refInfo,
          },
          path,
        },
      }
    })
    // Listen for isFetching changes so refInfo and path are restored after the query is refetched.
  }, [refInfo, path, layoutQueryKey, isFetching])
}
